<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="addForm" :rules="rules" ref="addForm" >

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" prop="institutionCode">
                <el-select v-model="addForm.institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="护理类型" prop="nursingTypeCode">
                <el-select v-model="addForm.nursingTypeCode" placeholder="选择护理类型" clearable filterable @change="changeNursingTypeCode" style="width:100%">
                  <el-option
                      v-for="item in nursingTypeList"
                      :key="item.nursingTypeCode"
                      :label="item.name"
                      :value="item.nursingTypeCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="名称" prop="name">
                <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="排序" prop="sort">
                <el-input v-model.number="addForm.sort" placeholder="请输入排序"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="状态" required prop="status">
                <el-select v-model="addForm.status" placeholder="请选择状态" style="width:100%">
                  <el-option
                      v-for="item in status2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>

        </el-form>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Edit',
  props:['arr_ins'],
  data() {
    return {
      loading: false,

      nursingTypeList: [],

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        nursingItemCode:'',
        name:'',
        sort:'',
        institutionCode:'',
        nursingTypeCode:'',
        status:''
      },

      status2: [{
        value: 0,
        label: '正常'
      }, {
        value: 1,
        label: '被禁用'
      }],

      rules:{
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        sort: [
          {required: true, message: '请输入排序', trigger: 'blur'},
          {type: 'number', message: '排序必须为数字值', trigger: 'blur'}
        ],
        nursingTypeCode: [
          {required: true, message: '请选择护理类型', trigger: 'blur'},
        ],

      }

    }
  },

  methods: {

    init(row){
      this.addForm.name = row.name;
      this.addForm.sort = row.sort;
      this.addForm.nursingTypeCode=row.nursingTypeCode;
      this.addForm.nursingItemCode=row.nursingItemCode;
      this.addForm.status=row.status
      this.addForm.institutionCode = row.institutionCode;

      this.getNursingTypeList();

    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    insChange(val){
      this.addForm.institutionCode = val;

      this.nursingTypeList = [];
      this.addForm.nursingTypeCode = '';
      this.getNursingTypeList();

    },

    getNursingTypeList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'NursingType/InsList',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.addForm.institutionCode,
        }
      }).then((response) => {
        //console.log(response.data);
        if (response.data.error == 0) {
          this.nursingTypeList = response.data.data;
          //this.nursingTypeCode = this.nursingTypeList[0].nursingTypeCode;
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingItem/GovEditIns",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;

            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else {
              this.$message({type: 'info', message: '编辑失败'});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
